import CandidatesAdministrationTabChildren from "./candidates/CandidatesAdministrationTabChildren";
import ReviewersAdministrationTabChildren from "./reviewers/ReviewersAdministrationTabChildren";
import CandidateEditionTabChildren from "./candidates/CandidateEditionTabChildren";
import ReviewerEditionTabChildren from "./reviewers/ReviewerEditionTabChildren";
import { RouterView } from "vue-router";

const Domains = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/domains/Domains.vue"
  );
const Competences = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/competences/Competences.vue"
  );
const Questions = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/questions/Questions.vue"
  );
const Scenarios = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/scenarios/Scenarios.vue"
  );
const CertificationCycles = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/certification-cycle/CertificationCycle.vue"
  );
const Candidates = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/candidates/CandidatesAdministration.vue"
  );
const CandidateDetails = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/candidates/CandidateDetails.vue"
  );
const Reviewers = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/reviewers/Reviewers.vue"
  );
const ReviewerDetail = () =>
  import(
    /* webpackChunkName: "Rest" */ "@/components/certipers-admin/administration/reviewers/ReviewerDetail.vue"
  );

export default [
  {
    path: "domains",
    name: "admin-domains",
    component: Domains,
  },
  {
    path: "Competences",
    name: "admin-competences",
    component: Competences,
  },
  {
    path: "questions",
    name: "admin-questions",
    component: Questions,
  },
  {
    path: "scenarios",
    name: "admin-scenarios",
    component: Scenarios,
  },
  {
    path: "certificationCycles",
    name: "admin-certificationCycles",
    component: CertificationCycles,
  },
  {
    path: "candidates",
    component: RouterView,
    children: [
      {
        path: "",
        name: "admin-candidates",
        children: CandidatesAdministrationTabChildren,
        component: Candidates,
        redirect: { name: "admin-candidates-candidatesList" },
      },
      {
        path: "details",
        name: "admin-candidate-edition",
        children: CandidateEditionTabChildren,
        component: CandidateDetails,
        redirect: { name: "admin-candidates-certification-project" },
      },
    ],
  },

  {
    path: "reviewers",
    component: RouterView,
    children: [
      {
        path: "",
        name: "admin-reviewers",
        children: ReviewersAdministrationTabChildren,
        component: Reviewers,
        redirect: { name: "admin-reviewers-list" },
      },
      {
        path: "",
        name: "admin-reviewers-edition",
        children: ReviewerEditionTabChildren,
        component: ReviewerDetail,
        redirect: (to) => {
          return {
            name: "admin-reviewers-profile",
            params: { userId: to.params.userId },
          };
        },
      },
    ],
  },
];
